import { Component, inject, ViewChild } from "@angular/core";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { TranslateModule } from "@ngx-translate/core";
import { firstValueFrom } from "rxjs";
import { OTPError } from "src/classes/OTPError";
import { ROUTES_CONFIG } from "src/config/routes.config";
import { STORAGE } from "src/config/storage.config";
import { SessionLoginTraditional } from "src/interfaces/session/session-login-traditional";
import { SessionService } from "src/services/session.service";
import { PrefixOmsComponent } from "../../../prefixes/impl/prefix-oms/prefix-oms.component";
import { PrefixWacComponent } from "../../../prefixes/impl/prefix-wac/prefix-wac.component";
import { TemplateTextComponent } from "../../../prefixes/templates/template-text/template-text.component";
import { DialogTitle } from "../../template/dialog-template.component";
import { DialogComponent } from "../dialog.component";

export interface SessionTimedoutDialogData {
  title: DialogTitle;
  message: string;
  showOTP: boolean;
}

@Component({
  selector: "app-session-timedout",
  imports: [TranslateModule, PrefixOmsComponent, PrefixWacComponent, MatProgressSpinner],
  templateUrl: "./session-timedout.component.html",
  styleUrl: "./session-timedout.component.less",
})
export class SessionTimedoutComponent extends DialogComponent<SessionTimedoutDialogData, { success: boolean }> {
  private session: SessionService;
  public isLoading: boolean;

  @ViewChild("username")
  public username: TemplateTextComponent | null;

  @ViewChild("password")
  public password: TemplateTextComponent | null;

  @ViewChild("otp")
  public otp: TemplateTextComponent | null;

  public constructor() {
    super();
    this.session = inject(SessionService);
    this.isLoading = false;
    this.username = null;
    this.password = null;
    this.otp = null;
  }

  public async login(): Promise<void> {
    const usernameField = this.username;
    const passwordField = this.password;

    if (usernameField && passwordField) {
      const username = usernameField.value;
      const password = passwordField.value;

      this.isLoading = true;

      try {
        if (username && password) {
          await this.handleLogin({
            cdjID: username,
            wacPassword: password,
            RoleID: localStorage.getItem(STORAGE.ROLE_ID),
            WorkspaceID: localStorage.getItem(STORAGE.WORKSPACE_ID),
          });
        } else {
          throw new Error("Invalid form");
        }
      } catch (err) {
        console.error(err);
      }

      this.isLoading = false;
    } else {
      throw new Error("Could not find username or password References");
    }
  }

  public async loginOTP(): Promise<void> {
    try {
      this.isLoading = true;
      await this.session.checkOTP(this.otp?.value || "", true);
      if ((await firstValueFrom(this.session.authenticated)) == true) {
        this.close({ success: true });
        // this.toggleCheck(false);
        // const contentid = this.route.snapshot.queryParams["contentid"];
        // await this.router.navigate(contentid ? ["/app/content", contentid] : ["/app/home"]);
      }
    } catch (error) {
      if (error instanceof OTPError) {
        console.log("OTP was incorrect");
      } else {
        console.error(error);
      }
    } finally {
      this.isLoading = false;
    }
  }

  public async logout(): Promise<void> {
    this.session.disconnect();
    this.close({ success: false });
  }

  private async handleLogin(data: SessionLoginTraditional): Promise<void> {
    try {
      await this.session.connect(data, ROUTES_CONFIG.reloginUrl, true);
      if ((await firstValueFrom(this.session.authenticated)) == true) {
        this.close({ success: true });
        // this.toggleCheck(false);
        // const contentid = this.route.snapshot.queryParams["contentid"];
        // await this.router.navigate(contentid ? ["/app/content", contentid] : ["/app/home"]);
      }
    } catch (error) {
      // if (error instanceof OTPError) {
      // }
      //  else if (error instanceof JWTError) {
      //   this.snackbar.open<string>(ErrorMessageComponent, "LOGIN.ERRORS.JWT");
      //   this.router.navigate(["/"]);
      // } else {
      console.error(error);
      // }
    }
  }
}
